"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function DonkereCta() {
  const {
    ref: leftRef,
    isVisible: leftVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const {
    ref: rightRef,
    isVisible: rightVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  return <section className="w-full bg-dark-background py-24">
      <div className="mx-auto grid max-w-7xl grid-cols-1 gap-0 md:grid-cols-2">
        {}
        <div ref={leftRef} className={`flex flex-col items-center justify-center gap-8 px-8 py-16 text-center transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] md:px-12 ${leftVisible ? "translate-x-0 opacity-100" : "-translate-x-12 opacity-0"}`}>
          <div className="relative h-48 w-full max-w-sm">
            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1511866/img/inspection_request_illustration.png" alt="Keuring aanvragen illustratie" className="h-full w-full object-contain" />
          </div>
          <h3 className="text-3xl font-semibold text-foreground-dark">
            Keuring aanvragen?
          </h3>
          <Link to="/ContactPage">
            <Button size="lg" className="bg-secondary text-foreground-secondary hover:scale-105 hover:bg-secondary-hover hover:shadow-medium active:bg-secondary-active">
              Nu aanvragen
            </Button>
          </Link>
        </div>

        {}
        <div ref={rightRef} className={`flex flex-col items-center justify-center gap-8 border-t border-border-light px-8 py-16 text-center transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] md:border-l md:border-t-0 md:px-12 ${rightVisible ? "translate-x-0 opacity-100" : "translate-x-12 opacity-0"}`}>
          <div className="relative h-48 w-full max-w-sm">
            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1511866/img/customer_service_illustration.png" alt="Contacteer ons illustratie" className="h-full w-full object-contain" />
          </div>
          <h3 className="text-3xl font-semibold text-foreground-dark">
            Contacteer ons!
          </h3>
          <Link to="/ContactPage">
            <Button size="lg" className="bg-secondary text-foreground-secondary hover:scale-105 hover:bg-secondary-hover hover:shadow-medium active:bg-secondary-active">
              Contact
            </Button>
          </Link>
        </div>
      </div>
    </section>;
}